export default __webpack_public_path__ + "static/media/failed.b52c7f61.svg";